import { useEffect } from "react";

// Some WebViews (notably generic "wrap my website as an Android app" shells)
// resolve CSS dynamic-viewport units (100dvh) to a stale/incorrect value and
// never recompute it, leaving a blank gap at the bottom of fixed-height,
// overflow-hidden screens even though the same page is full-height in Chrome.
// window.innerHeight is reported correctly by virtually every WebView engine
// even when its own dvh implementation isn't, so we measure it directly and
// publish it as a CSS var; consumers use var(--app-height, 100dvh) so normal
// browsers (where dvh is already correct) are unaffected.
export function useRealViewportHeight() {
  useEffect(() => {
    const setAppHeight = () => {
      const h = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      document.documentElement.style.setProperty("--app-height", `${h}px`);
    };
    setAppHeight();
    window.addEventListener("resize", setAppHeight);
    window.addEventListener("orientationchange", setAppHeight);
    window.visualViewport?.addEventListener("resize", setAppHeight);
    return () => {
      window.removeEventListener("resize", setAppHeight);
      window.removeEventListener("orientationchange", setAppHeight);
      window.visualViewport?.removeEventListener("resize", setAppHeight);
    };
  }, []);
}
